import React, { useEffect, useRef, useState } from 'react';

import { useParams } from 'react-router-dom';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core';
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiArrowRight,
  mdiCar,
  mdiKeyOutline,
  mdiMapMarkerOutline,
  mdiPackage,
  mdiPhone,
  mdiStateMachine,
  mdiWarehouse,
} from '@mdi/js';
import jMoment from 'moment-jalaali';
import { translate } from '../../utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { getBundleWithIdAction, updateBundleStatusActions } from './actions';
import { Store } from '../../redux/reducers';
import { Bundle } from './interfaces';
import {
  cancelOrderAction,
  getOrdersAction,
  updateOrderStatusActions,
} from '../orders/actions';
import List from './deliverToDriverList';
import handleNotfication from '../../utils/handleNotification';
import theme from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    contentBox: {
      padding: theme.spacing(2),
      fontSize: '14px',
      fontWeight: 500,
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: '10px',
      fontWeight: 400,
    },
    titleBox: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.contrastText,
      padding: theme.spacing(2),
      borderRadius: '4px 4px 0 0',
    },
    paperHistory: {
      '@media (min-width: 768px)': {
        width: '40%',
      },
    },
    missingOppositeContent: {
      '&::before': {
        flex: 'none',
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentLabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '12px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
  })
);

const DeliverToDriver = ({ history }) => {
  const dispatch = useDispatch();
  const bundle = useSelector((state: Store) => state.bundles.bundle) as Bundle;
  const ordersStore = useSelector((state: Store) => state.orders);
  const { id } = useParams();
  const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const [inputValue, setInputValue] = useState<string>('');
  const [openConfirm, setOpenConfirm] = useState(false as boolean);
  const onclose = () => {
    setOpenConfirm(false);
  };

  useEffect(() => {
    if (id) {
      dispatch(getBundleWithIdAction({ id: id }));
      dispatch(getOrdersAction({ 'bundleId.equals': id, page: 0, size: 1000 }));
    }
  }, []);

  const handleSubmitBarcode = (event: InputEvent) => {
    event.preventDefault();
    const findOrder = ordersStore.ordersList.find(
      (el: any) => el.id === +inputValue
    );
    if (findOrder) {
      setSelectedItems(prevState => [...prevState, findOrder.id]);
    } else {
      handleNotfication('شناسه سفارش مورد نظر پیدا نشد', 'warn');
    }
    setInputValue('');
  };

  const classes = useStyles();

  const handleClickItems = (id: number) => {
    if (selectedItems.find(el => el === id)) {
      setSelectedItems(prevState => [...prevState.filter(el => el !== id)]);
    } else {
      setSelectedItems(prevState => [...prevState, id]);
    }
  };

  const handleSubmitBundle = () => {
    function callback() {
      setOpenConfirm(false);
      handleNotfication('مرسوله انتخابی با موفقیت تغییر وضعیت یافت', 'success');
      window.open(`/deliver-driver-receipt/${id}`);
    }
    dispatch(
      updateBundleStatusActions({
        id: id,
        body: '"LOADED"',
        pagination: {},
        callback: callback(),
      })
    );
  };

  const handleCancelBundle = (values: Record<string, string>) => {
    dispatch(updateOrderStatusActions(values));
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = ordersStore.ordersList.map((n: any) => n.id);
      setSelectedItems(newSelecteds);
      return;
    }
    setSelectedItems([]);
  };

  return (
    <div className={classes.root}>
      <Grid container justify={'space-between'} spacing={5}>
        <Grid item xs={12} sm={6}>
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              تحویل مرسوله {id} به راننده
            </Typography>
          </div>

          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}
          >
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </Grid>
        <Grid item xs={12} sm={4}>
          {/*// TODO: print button*/}
        </Grid>
      </Grid>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.icon}
                />
                {'نام راننده:  '}
              </span>

              <span>{bundle?.driverName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiPhone} size={1} className={classes.icon} />
                {`شماره تماس راننده:  `}
              </span>

              <span dir={'ltr'}>{bundle?.driverPhoneNumber}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiKeyOutline} size={1} className={classes.icon} />
                {`شناسه راننده راننده:  `}
              </span>

              <span>{bundle?.driverId}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCar} size={1} className={classes.icon} />
                {`نوع خودرو:  `}
              </span>

              <span>{translate(bundle?.vehicleClass)}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {`مرکز/انبار:  `}
              </span>
              <span>{bundle?.sourceName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWarehouse} size={1} className={classes.icon} />
                {`تاریخ تحویل:  `}
              </span>
              <span>
                {bundle?.deliveryDate &&
                  `${jMoment(bundle?.deliveryDate, 'YYYY/MM/DD')
                    .locale('fa')
                    .format('jYYYY/jMM/jDD')}`}
              </span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiPackage} size={1} className={classes.icon} />
                {`تعداد سفارش:  `}
              </span>
              <span>{bundle?.ordersCount}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiStateMachine}
                  size={1}
                  className={classes.icon}
                />
                {`وضعیت مرسوله:  `}
              </span>
              <span>{translate(bundle?.status, 'bundle')}</span>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Grid container justify={'center'}>
        <Grid xs={6}>
          <Grid>
            <form onSubmit={handleSubmitBarcode}>
              <TextField
                fullWidth
                variant={'filled'}
                id="serialNumber"
                name="name"
                autoFocus
                value={inputValue}
                onChange={e => setInputValue(e.target.value)}
                label="شناسه سفارش رو اسکن کنید"
              />
            </form>
          </Grid>
        </Grid>
      </Grid>
      <Box mt={4} />
      <Grid container>
        {ordersStore.loading ? (
          <Grid xs={12}>
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          </Grid>
        ) : (
          <>
            {ordersStore.ordersList.length > 0 ? (
              <List
                data={ordersStore.ordersList}
                cancelOrderDispatch={handleCancelBundle}
                bundleId={id}
                loading={false}
                handleClickItem={handleClickItems}
                selectedItems={selectedItems}
                selectAll={handleSelectAllClick}
              />
            ) : (
              <Typography variant="h3" component="div">
                سفارشی موجود نیست
              </Typography>
            )}
          </>
        )}
      </Grid>
      <Box mt={5} />
      <Grid item container justify="flex-end" xs={12}>
        <Button
          style={{ marginRight: 'auto' }}
          disabled={!(selectedItems.length === ordersStore?.ordersList?.length)}
          size="large"
          data-cy="search"
          autoFocus
          onClick={() => setOpenConfirm(true)}
          variant="contained"
          color="secondary"
        >
          تحویل مرسوله به راننده
        </Button>
      </Grid>

      <Dialog
        fullWidth
        open={openConfirm}
        onClose={onclose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          ></div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiCar} size={4} color={theme.palette.blue.main} />
          </div>
          <div
            className={classes.cancelTitle}
          >{`از تایید تحویل تمام سفارش ها به راننده مطمئنید؟`}</div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={() => setOpenConfirm(false)}
                variant="contained"
                color="secondary"
                size="large"
              >
                {`خیر`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                onClick={handleSubmitBundle}
                variant="contained"
                size="large"
              >
                {`بله`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeliverToDriver;
